import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function SellerCard({ images, title, subtitle, distance, live, time, onClick }) {
  const { t } = useTranslation();
  const [imgError, setImgError] = useState(false);

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-xl shadow-[0px_1px_5px_rgba(0,0,0,0.1)] w-full h-full hover:shadow-lg transition-shadow duration-300 mb-2 cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-t-xl bg-gray-50 aspect-square flex items-center justify-center">
        <img
          src={images && !imgError ? images : "/images/User.png"}
          onError={() => setImgError(true)}
          alt={title || "Advertiser Image"}
          className="w-full h-full object-cover rounded-t-xl bg-gray-50"
        />
        {live && (
          <span className="absolute top-2 left-2 bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded-full z-10">
            {t("common.live", "LIVE")}
          </span>
        )}
      </div>
      <div className="p-[15px] flex justify-between items-start gap-[10px]">
        <div className="flex flex-col gap-[5px] w-full overflow-hidden">
          <h3 className="heading-web-h5 text-zinc-950 truncate w-full" title={title}>
            {title}
          </h3>
          {subtitle && (
            <p className="body-md text-zinc-500 truncate w-full" title={subtitle}>
              {subtitle}
            </p>
          )}
          {(distance !== undefined && distance !== null) && (
            <p className="flex gap-[5px] items-center">
              <span className="bg-blue-50 text-blue-600 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider">
                {distance < 0.1 ? t("common.nearby", "Nearby") : `${Number(distance).toFixed(1)} km`}
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SellerCard;

